import styled from "styled-components"

import { hexCodetoRGBA } from "app/static/frontend/imports/desktopHelperFunctions"

export const ContainerWithColor = styled.div`
    --organization-primary-color-0: ${window.organization_design.primary_color};
    --organization-primary-color-1: ${hexCodetoRGBA(window.organization_design.primary_color, 0.1)};
    --organization-primary-color-2: ${hexCodetoRGBA(window.organization_design.primary_color, 0.2)};
    --organization-primary-color-3: ${hexCodetoRGBA(window.organization_design.primary_color, 0.3)};
    --organization-primary-color-4: ${hexCodetoRGBA(window.organization_design.primary_color, 0.4)};
    --organization-primary-color-5: ${hexCodetoRGBA(window.organization_design.primary_color, 0.5)};
    --organization-primary-color-6: ${hexCodetoRGBA(window.organization_design.primary_color, 0.6)};
    --organization-primary-color-7: ${hexCodetoRGBA(window.organization_design.primary_color, 0.7)};
    --organization-primary-color-8: ${hexCodetoRGBA(window.organization_design.primary_color, 0.8)};
    --organization-primary-color-9: ${hexCodetoRGBA(window.organization_design.primary_color, 0.9)};
`
